import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "mp_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 inset-x-4 md:left-6 md:right-auto md:max-w-md z-[70] bg-navy text-white border border-white/10 shadow-2xl"
        >
          <div className="p-6">
            <div className="flex items-center gap-2.5 mb-3">
              <Cookie className="w-5 h-5 text-orange" />
              <span className="font-display text-lg">Cookie</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              Utilizziamo cookie tecnici per il funzionamento del sito e, previo consenso, cookie non
              essenziali. Puoi accettare o rifiutare. Maggiori dettagli nella{" "}
              <Link to="/privacy-policy" className="text-orange hover:underline" data-testid="cookie-privacy-link">
                Privacy Policy
              </Link>.
            </p>
            <div className="flex gap-3 mt-5">
              <button
                onClick={() => choose("rejected")}
                data-testid="cookie-reject"
                className="flex-1 border border-white/25 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] hover:bg-white/10 transition-colors"
              >
                Rifiuta
              </button>
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept"
                className="flex-1 bg-orange py-2.5 text-xs font-semibold uppercase tracking-[0.12em] hover:brightness-110 transition-[filter]"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
